import {
	createRouter,
	createWebHistory
} from "vue-router"

import {
	Route
} from "@/types"

import {
	Auth
} from 'aws-amplify'

import {
	trackPageView
} from '@/utilities/analytics'

// Import all of the resource routes files
function loadRoutes() {
	const context = require.context("@/modules", true, /routes.ts$/i)
	return context
		.keys()
		.map(context) // import module
		.map((m: any) => m.route) // get `default` export from each resolved module
}

// Define the routes
const routes: Route[] = []
const resourceRoutes = loadRoutes()

resourceRoutes.forEach((moduleRoutes) => {
	moduleRoutes.forEach((route: Route) => {
		routes.push(route)
	})
})

// Create the router instance and pass the `routes` option
export const router = createRouter({
	history: createWebHistory(), // use history mode
	routes
})

router.beforeEach(async (to, from, next) => {
	if(to.meta.public) {
		next()
		return
	}

	const user = await authenticate()

	if(!user) {
        next({name: 'SignIn', query: {redirect: to.fullPath}})
		return
    }

	next()
})

router.afterEach((to) => {
	trackPageView(to)
})

async function authenticate(){
    try {
        const user = await Auth.currentAuthenticatedUser()
        return user
    }
    catch(e) {
        return false
    }
}